import React, {useState} from 'react';
import {Link, useParams} from "react-router-dom";
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    v3Level10Element
} from "../../../services/metadata.service";

// name: display on preview top
// key: column# of excel sheet
// json_key: key for posting data to api
const columns = [
    {name: 'Element#', key: 0, json_key: 'element_no', data_key: 'element_no'},
    {name: 'Code', key: 1, json_key: 'code', data_key: 'code'},
    {name: 'Full Name', key: 2, json_key: 'full_name', data_key: 'full_name'},
    {name: 'Definition', key: 3, json_key: 'definition', data_key: 'definition'},
    {name: 'Session#', key: 4, json_key: 'session_no', data_key: 'session_no'},
    {name: 'Level10_KSAB_Dimensions', key: 5, json_key: 'level10_ksab_dimensions', data_key: 'level10_ksab_dimensions'},
    {name: 'Unit#', key: 6, json_key: 'unit_no', data_key: 'unit_no'},
    {name: 'DQCO#', key: 7, json_key: 'dqco_no', data_key: 'dqco_no'},
    {name: 'DQC#', key: 8, json_key: 'dqc_no', data_key: 'dqc_no'},
    {name: 'DQM#', key: 9, json_key: 'dqm_no', data_key: 'dqm_no'},
    {name: 'Stakeholder#', key: 10, json_key: 'stakeholder_no', data_key: 'stakeholder_no'},
    {name: 'DQA#', key: 11, json_key: 'dqa_no', data_key: 'dqa_no'},
]

const tableCols = [
    {
        label: 'Element#',
        field: 'element_no', width: 150
    },
    {
        label: 'Code',
        field: 'code', width: 150
    },
    {
        label: 'Full Name',
        field: 'full_name', width: 150
    },
    {
        label: 'Definition',
        field: 'definition', sort: 'disabled', width: 150
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]


export default function Level10ElementPage() {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const table_row__additional_rendering = (row) => {
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Level10 Element'}
            modal_title={'Level10 Element - Data Preview'}
            sheet_name={'Level10 (Element)'}
            columns={columns}
            tableCols={tableCols}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={v3Level10Element.listData}
            postAPI={v3Level10Element.postData}
            deleteAPI={v3Level10Element.deleteEntity}
            updateAPI={v3Level10Element.updateEntity}
            preRemoveAPI={v3Level10Element.preRemoveCheck}
        />
    );
}
